import React, { useContext } from 'react'
import { Modal, Button } from 'antd'
import { CheckOutlined } from '@ant-design/icons'
import { useIntl } from 'react-intl'

import { getRechargeTypeInfo, getRechargeTypeDisplayName } from '../../util/recharge-type-info'
import { ThemeContext } from '../../context/themeContext'
import { DARK_THEME } from '@vacationtracker/shared/constants/ThemeSetting'

import IntlMessages from '../../util/IntlMessages'

import { RechargeType } from '@vacationtracker/shared/types/recharge-type'

import './styles.less'

interface RechargeTypeResultProps {
  visible: boolean
  rechargeType: RechargeType | null
  onClose: () => void
}

export const RechargeTypeResult: React.FC<RechargeTypeResultProps> = ({ visible, rechargeType, onClose }) => {
  const { formatMessage } = useIntl()
  const { theme } = useContext(ThemeContext)
  const isDark = theme === DARK_THEME

  if (!rechargeType) {
    return null
  }

  const info = getRechargeTypeInfo(rechargeType, formatMessage)
  const displayName = getRechargeTypeDisplayName(rechargeType, formatMessage)

  return (
    <Modal open={visible} onCancel={onClose} footer={null} width={560} centered className="recharge-result-modal" closable={true}>
      <div className={`result-content ${isDark ? 'dark' : ''}`}>
        <div className="result-emoji">{info.emoji}</div>

        <h2 className="result-title">{displayName}</h2>
        <p className="result-tagline">{info.tagline}</p>

        <div className="result-pto-card">
          <div className="pto-label">
            <IntlMessages id="rechargeType.result.optimalPTOLabel" />
          </div>
          <div className="pto-value">{info.optimalPTO}</div>
        </div>

        <div className="result-tips">
          <h4 className="tips-title">
            <IntlMessages id="rechargeType.result.tipsTitle" />
          </h4>
          <ul className="tips-list">
            {info.tips.map((tip, index) => (
              <li key={index} className="tip-item">
                <CheckOutlined className="tip-check" />
                <span>{tip}</span>
              </li>
            ))}
          </ul>
        </div>

        <Button type="primary" size="large" onClick={onClose} className="result-done-btn" block>
          <IntlMessages id="app.done" />
        </Button>
      </div>
    </Modal>
  )
}
